import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'

export const RelativeTime: React.FC<{ timestamp: number | Dayjs }> = ({
  timestamp,
}) => {
  const ts = typeof timestamp === 'number' ? dayjs(timestamp) : timestamp
  return (
    <span
      title={ts.format('L LTS')}
      sx={{
        whiteSpace: 'nowrap',
      }}
    >
      {ts.fromNow()}
    </span>
  )
}
